<template>  
  <div class="">
    <div class="row justify-content-center">
      <div class="col-12 col-md-12">
        <div>
          <b-tabs nav-class="no-tabs" :no-nav-style="true" v-model="categoryIndex">
            <b-tab :id="`cat_${xz}`" v-for="(cat, xz) in categoriesItems" :key="`cat_${xz}`">
              <template #title>
                <h3><img :src="`./assets/${kebabCase(cat.category)}.png`" /> <span>{{ cat.category }}</span></h3>
              </template>

              <div class="d-block d-md-none">
                <b-dropdown class="filter-preguntas-home">
                  <template #button-content>
                    <h6>Explorar las respuestas por:</h6>
                    <h4><strong>{{ currentCategory }}</strong></h4>
                  </template>
                  <b-dropdown-item @click="showPreguntas(xz, ix, s)" v-for="(s, ix) in cat.subcategories" :key="`tabs_${ix}`">{{ s }}</b-dropdown-item>
                </b-dropdown>
              </div>
              <b-tabs v-if="xz==categoryIndex" v-model="tabindex_n" card class="menu-home">
                <b-tab :ref="`sub_${xz}_${ix}`" :id="`sub_${xz}_${ix}`" :title="s" v-for="(s, ix) in cat.subcategories" :key="`sub_${xz}_${ix}`">
                  <div class="mt-3">
                    <CategoryPreguntas :data_preguntas="filteredSubcategory(s)"/>
                  </div>
                </b-tab>
              </b-tabs>

              <div class="d-md-none d-block btn-next">
                <b-button v-if="tabindex_n < cat.subcategories.length - 1" @click="showPreguntas(xz, tabindex_n+1)">Siguiente tema: {{ cat.subcategories[tabindex_n+1] }} <iconArrowRight /></b-button>
                <b-button v-if="tabindex_n == cat.subcategories.length - 1" @click="showPreguntas(xz, 1)">Siguiente tema: {{ cat.subcategories[0] }} <iconArrowRight /></b-button>
              </div>

            </b-tab>
          </b-tabs>

        </div>     
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .card-header {
    
    @media (max-width: 600px) {
      display: none;
    }
  }

  .filter-preguntas-home {
    width: 100%;
    border: none;

    button {
      color: #000 !important;
      background: #e3e3e3 !important;
      border: none;
      border-radius: 0;
      white-space: inherit;    

      &:hover,
      &:active,
      &:focus {
        color: #000;
        background-color: #e3e3e3;
      }
    }
  }

  .dropdown-menu.show {
   display: block;
   width: calc(100% - 10px);
   border-radius: 0;

   li {    
    border-bottom: dashed 1px #e3e3e3;

    a {
      padding: 10px 15px;
      font-size: 18px;
      font-weight: 600;
    }
   }
  }

  .btn-next {
    button {
      display: block;
      width: 100%;
      border-radius: 0;
      background-color: #e3e3e3 !important;
      color: #333 !important;
      border: none;
      font-size: 15px;
      font-weight: 600;
      padding: 15px;
    }
  }
</style>

<script>

import IframeResizer from '@/utils/iframe-resizer'
import CategoryPreguntas from '@/components/CategoryPreguntas.vue'
import iconArrowRight from '@/components/iconArrowRight.vue'
import { filter, kebabCase, groupBy, map, uniq  } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'Home',
  components: {    
    CategoryPreguntas,
    iconArrowRight
},
  data() {
    return {
      currentCategory: `Fondos de reconstrucción`,
      tabIndex: [0,0,0],
      tabindex_n: 0,
      categoryIndex: 0
    }
  },
computed: {
  ...mapState({
      data_preguntas: state => state.encuesta.data_preguntas,     
    }),
    categoriesButtons() {
      return uniq(map(this.data_preguntas, 'category'))
    },
    categoriesItems() {
      return map(groupBy(this.data_preguntas, 'category'), (items, category) => {
        return {
          category: category,
          items: items,
          subcategories: uniq(map(items, 'subcategory'))
        }
      })
    }
},
watch: {
  categoryIndex(v) {
    this.tabindex_n = 0
    if(this.categoriesItems[v])
      this.currentCategory = this.categoriesItems[v].subcategories[0]
  }
},
methods: {
  kebabCase,
  showPreguntas(xz, index) {
    let ar = this.tabIndex
    ar[xz] = index
    this.tabIndex = ar
    this.currentCategory = this.categoriesItems[xz].subcategories[index]
    this.tabindex_n = index
  },
  pregunta(id) {      
    return find(this.data_preguntas, ['id_question', parseInt(id)])
  },
  filteredPreguntas(category_filter) {
    return filter(this.data_preguntas, (item) => {        
      if(kebabCase(item.category) == kebabCase(category_filter)){
        return item
      }
    })
  },
  filteredSubcategory(category_filter) {
    return filter(this.data_preguntas, (item) => {
      if(kebabCase(item.subcategory) == kebabCase(category_filter)){
        return item
      }
    })
  }
},
  mounted () {
    IframeResizer.create() 
    
  },  
}
</script>